<div class="container">
  <div class="container__bg"></div>
  <div class="container__subject"></div>
  <div class="container__time">
    <app-time></app-time>
  </div>
</div>
